import React from 'react'
import { Box } from '@mui/material'
import type { SxProps, Theme } from '@mui/material'

export interface AppDrawerBodyProps {
  children?: React.ReactNode
  padding?: SxProps<Theme>
  sx?: SxProps<Theme>
}

const DEFAULT_PADDING: SxProps<Theme> = { px: 1.5, pt: 1.5, pb: 1.5 }

const AppDrawerBody: React.FC<AppDrawerBodyProps> = ({
  children,
  padding = DEFAULT_PADDING,
  sx,
}) => (
  <Box
    sx={[
      { flex: 1, minHeight: 0, overflowY: 'auto', overflowX: 'hidden' },
      ...(Array.isArray(padding) ? padding : [padding]),
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {children}
  </Box>
)

export default AppDrawerBody
